import { useState } from 'react';
import { Link } from 'react-router-dom';
import api, { formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ArrowLeft, Mail } from 'lucide-react';

const APP_ICON = "https://static.prod-images.emergentagent.com/jobs/3c404c7b-5045-4d45-8ddd-9111c2fbc8c7/images/1edd49db85dba9cc04f46bd52929381e881d2b7dac026dd5c68dd6bec34e756c.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F9F8F6]" data-testid="forgot-password-page">
      <Card className="w-full max-w-md border-[#EAE6DF] shadow-sm">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-3">
            <img src={APP_ICON} className="w-14 h-14 rounded-xl" alt="Logo" />
          </div>
          <CardTitle className="text-3xl text-[#2F3E3B] tracking-tight">Glemt adgangskode</CardTitle>
          <CardDescription className="text-[#5C706A] font-sans">
            {sent ? 'Tjek din email for et nulstillingslink' : 'Indtast din email for at nulstille din adgangskode'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-[#7F9C82]/10 rounded-full flex items-center justify-center mx-auto">
                <Mail className="w-8 h-8 text-[#7F9C82]" />
              </div>
              <p className="text-[#5C706A] font-sans text-sm">
                Hvis emailen er registreret, vil du modtage et link til at nulstille din adgangskode.
              </p>
              <Link to="/login">
                <Button variant="outline" className="border-[#7F9C82] text-[#7F9C82] hover:bg-[#7F9C82]/5 font-sans"
                  data-testid="back-to-login-button">
                  <ArrowLeft className="w-4 h-4 mr-2" /> Tilbage til login
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm font-sans">{error}</div>}
              <div className="space-y-1.5">
                <Label className="font-sans text-[#2F3E3B]">Email</Label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="din@email.dk"
                  required className="border-[#EAE6DF] focus:ring-[#7F9C82]/30 focus:border-[#7F9C82]"
                  data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#7F9C82] hover:bg-[#658368] text-white font-sans font-medium"
                data-testid="forgot-submit-button">
                {loading ? 'Sender...' : 'Send nulstillingslink'}
              </Button>
              <p className="text-center">
                <Link to="/login" className="text-sm font-sans text-[#7F9C82] hover:underline" data-testid="back-login-link">
                  <ArrowLeft className="w-3 h-3 inline mr-1" />Tilbage til login
                </Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
